import React from "react";
import Loading from "../../../../Common/Loading";
import {
  renderCategoryRoute,
  renderHeaderPrice,
  renderItemSinglePath,
} from "../../../../Common/Function/index";
import { Link } from "react-router-dom";
import Pagination from "react-js-pagination";
import InSetBoxShadow from "../../../../Common/InSetBoxShadow";
import { Color } from "../../../../../Utils/styles";
import ItemListItem from "../../../../../App/Views/ItemsLIst/ItemListItem";

const FlatList = ({ data, loading, search, handleFilter, searchHandler, isApp, nextLoading }) => {
  const Empty = () => {
    return (
      isApp
        ? <p className="text-center nfs-14 my-3">مجموعه ای پیدا نشد !</p>
        : 
        <div className="col-12 text-center mt-5">
          <h4>مجموعه ای یافت نشد</h4>
        </div>

    );
  };
  if (loading) {
    return (
      <>
        {isApp
          ? <Loading height={"40px"} count={6} col={12} />
          : <Loading margin={""} count={4} col={12} />
        }
      </>
    );
  }

  return (
    <>
      {data && data.data
        ? data.data.length === 0
          ? Empty()
          : data.data
            ? data.data.map((item, id) => {
              return isApp ? <ItemListItem classBox={"mb-2"} data={item} key={id} /> : <Card data={item} key={id} />;
            })
            : Empty()
        : Empty()
      }

      <div className="d-flex align-items-center justify-content-center">
        {loading || (data && data.data && data.length == 0) ? (
          ""
        ) : (
          <>
            {isApp
              ? data.next_page_url &&
              <button
                className="btn btn-primary mb-4 mt-3 w-100"
                onClick={() => handleFilter("page", +data.current_page + 1, 15, true)}>
                {nextLoading ? "در حال دریافت" : "نمایش بیشتر"}
              </button>

              : <Pagination
                activePage={data && data.current_page}
                itemsCountPerPage={15}
                totalItemsCount={data && data.total}
                onChange={page => {
                  handleFilter("page", page);
                }}
                itemClass={"page-item"}
                linkClass={"page-link"}
              // hideFirstLastPages={true}
              />
            }
          </>
        )}
      </div>
    </>
  );
};

export default FlatList;
const Card = ({ data }) => {
  const renderImage = () => {
    if (data.header_image) {
      return data.header_image;
    } else {
      return data.images && data.images[0];
    }
  };
  const renderOff = () => {
    if (data.off) {
      return (
        <div
          style={{
            display: "flex",
            // flexDirection: "column",
            alignItems: "center",
            position: "absolute",
            backgroundColor: Color.white,
            top: "14px",
            borderBottomLeftRadius: "5px",
            // width: "100px",
            // transform: "rotate(45deg)",
            // right: "10px",
            justifyContent: "center",
            backgroundColor: "rgb(101, 203, 119)",
          }}
        >
          <div style={{}}>
            <h6
              style={{
                color: Color.white,
                fontSize: "12px",
                fontWeight: "400",
                padding: "2px 8px",
              }}
            >{`تخفیف رزرو  ${data.category.name} تا`}</h6>
          </div>
          <div
            style={{
              backgroundColor: "rgb(57, 175, 98)",
              padding: "3px 8px",
            }}
          >
            <h6
              style={{
                color: Color.white,
                fontSize: "12px",
                fontWeight: "400",
              }}
            >{`٪${Math.ceil(data.off.offpersentage)}`}</h6>
          </div>
          {/* <span
            style={{ color: Color.white, fontSize: "12px", fontWeight: "400" }}
          >{``}</span>
          <span className="" style={{ margin: "0 2px" }}></span>
          <span
            style={{ color: Color.white, fontSize: "10px", fontWeight: "300" }}
          >
            تخفیف
          </span> */}
        </div>
      );
    }
  };
  return (
    <div
      className="co-12 "
      style={{
        marginBottom: "10px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Link
        to={`${renderItemSinglePath(
          data.category && data.category.id,
          data.city && data.city[0].slug,
          data.slug
        )}`}
        style={{
          overflow: "hidden",
        }}
      >
        <InSetBoxShadow
          style={{
            overflow: "hidden",
          }}
        >
          <div
            style={{
              overflow: "hidden",
            }}
            className="item overflow-hidden d-flex justify-content-between item-card"
          >
            <img
              src={renderImage()}
              alt={data ? data.name : "nikotan | نیکوتن"}
              style={{
                overflow: "hidden",
              }}
            />
            {renderOff()}
            <div className="item-card-left">
              <div className="texts px-2">
                <div className="first-part  ">
                  <h5
                    style={{ color: "#404040", fontWeight: "500" }}
                    className="name mt-2"
                  >
                    {data.name}
                  </h5>
                </div>

                <div className="second-part h6 mb-2">
                  <p
                    className="address mb-2"
                    style={{
                      fontWeight: "400",
                    }}
                  >
                    {data && data.address}
                  </p>
                </div>
                <div className="d-flex justify-content-end flex-wrap mt-3 w-100">
                  {data &&
                    data.itemoptins &&
                    data.itemoptins.map((option, key) => (
                      <i
                        className={option.icon}
                        key={key}
                        style={{ color: "#000" }}
                      />
                    ))}
                </div>
              </div>

              {/* -------------- footer card --------------- */}
              <div
                className="px-2 d-flex justify-content-between align-items-center w-100 pb-2 item-card-footer "
                style={{
                  borderRight: "1px solid #eee",
                }}
              >
                <div className="d-flex justify-content-end align-items-center">
                  <h6 style={{ padding: "0", margin: "0", fontWeight: "400" }}>
                    {Math.ceil(data.comments_avg_score) || 5}
                  </h6>

                  <img
                    src={window.origin + "/WebSide/assets/images/star.png"}
                    alt="امتیاز"
                    style={{
                      width: "15px",
                      height: "15px",
                      marginRight: "5px",
                    }}
                  />
                </div>

                <div className="d-flex align-items-center flex-wrap justify-content-center">
                  <div className="text-center me-2">
                    <p className=""
                      style={{ textAlign: "right", fontWeight: "400" }} >
                      شروع قیمت از
                    </p>
                  </div>

                  {data && (
                    <div className="d-flex flex-column align-items-center">
                      <div className="label-price py-1 py-md-2">
                        <span
                          className=" text-white"
                          style={{
                            fontWeight: "400",
                          }}
                        >
                          {data.header_price
                            ? `${renderHeaderPrice(data)}`
                            : renderHeaderPrice(data)}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </InSetBoxShadow>
      </Link>
    </div>
  );
};
